import { AnalyticsClientImpl } from '../clients/AnalyticsClient';

import { store } from './store';

export const analyticsClient = new AnalyticsClientImpl(store, 'web');
